import React from 'react';
import { useDispatch } from 'react-redux';
import { next } from '../../../store/onboarding.duck';
import { Column } from '@shared/ui/atoms/StructuralLayout';
import { HeadlineMedium } from '@shared/ui/atoms/fonts/Headline';
import { BodyLarge } from '@shared/ui/atoms/fonts/Body';
import { PrimaryButton } from '@shared/ui/atoms/buttons/PrimaryButton';
import { useTranslation } from "react-i18next";
import { ButtonSize } from '@shared/ui/atoms/buttons/ButtonStyling';

export default function OnboardingCustomWhereabouts() {
  const dispatch = useDispatch();
  const {t} = useTranslation();

  return (
    <div className="onboarding">
      <Column className="onboarding__content">
        <img style={{width: 330, marginBottom: 40}}
             className="onboarding__image"
             src="/assets/images/onboarding-custom-whereabouts.svg" alt="" aria-hidden={true} />
        <HeadlineMedium style={{marginBottom: 12}}>{t('onboarding.custom-whereabouts-title')}</HeadlineMedium>
        <BodyLarge style={{marginBottom: 48}}>{t('onboarding.custom-whereabouts-description')}</BodyLarge>

        <PrimaryButton dataTest="onboarding-custom-whereabouts-next"
                       size={ButtonSize.Large}
                       text="button.got-it"
                       click={() => dispatch(next())}
                       fullWidth={true}/>
      </Column>
    </div>
  )
}
